/**
 * Animated SVG checkmark with pulsing circle background.
 * Used for success states after sending documents, negotiations, etc.
 */
interface AnimatedCheckmarkProps {
  size?: number
  className?: string
}

export function AnimatedCheckmark({ size = 48, className = '' }: AnimatedCheckmarkProps) {
  const circleR = size * 0.42
  const center = size / 2

  return (
    <div className={`relative inline-flex items-center justify-center ${className}`}>
      {/* Pulsing background circle */}
      <div
        className="absolute rounded-full bg-success-100 dark:bg-success-900/30 animate-success-pulse"
        style={{ width: size * 1.4, height: size * 1.4 }}
      />
      {/* SVG checkmark */}
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        className="relative z-10"
      >
        {/* Circle */}
        <circle
          cx={center}
          cy={center}
          r={circleR}
          className="stroke-success-500"
          strokeWidth={2.5}
          fill="none"
          strokeLinecap="round"
          style={{
            strokeDasharray: 2 * Math.PI * circleR,
            strokeDashoffset: 2 * Math.PI * circleR,
            animation: 'checkmark-circle 0.4s ease-out 0.1s forwards',
          }}
        />
        {/* Checkmark path */}
        <path
          d={`M${size * 0.3} ${size * 0.5} L${size * 0.45} ${size * 0.65} L${size * 0.72} ${size * 0.35}`}
          className="stroke-success-500"
          strokeWidth={2.5}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            strokeDasharray: 50,
            strokeDashoffset: 50,
            animation: 'checkmark-draw 0.35s ease-out 0.45s forwards',
          }}
        />
      </svg>
    </div>
  )
}
